import React from "react";
import CountUp from 'react-countup';

const CounterCard = ({value}) => {
    const counter = value.count;

  return (
    <div className="lg:w-[20rem] md:w-full h-[10rem] bg-[#133A50] border border-[#22BEFF] sm:p-[2rem] p-4 rounded-md flex justify-center items-center flex-col gap-2">
      <h1 className="sm:text-5xl text-4xl font-extrabold text-white"><CountUp end={counter} duration={value.time}/></h1>
      <p className="text-xl text-white">{value.text}</p>
    </div>
  );
};

export default CounterCard;
